import { useAccessibleRegion, useServiceAppState } from '@kc-console/context';

import type { Region } from '@kc-console/context';

interface RegionMenuStateProps {
  accessibleRegions: Array<Region>;
  currentRegion?: Region;
}

/** 주석 작성
 * ~~~을 콘솔 레이아웃에 맞게 재정의하여 제공하는 훅입니다.
 * @description
 * -
 */
export const useRefinedRegionMenuState = (): RegionMenuStateProps => {
  const { data: accessibleRegions = [] } = useAccessibleRegion();
  const {
    state: { region: currentRegion },
  } = useServiceAppState();

  return {
    currentRegion,
    accessibleRegions,
  };
};
